/** Shared compact filter dropdown tokens (aligned with commissions filters). */
export const FILTER_LABEL_CLASS =
  "mb-1.5 block text-[12px] font-medium leading-none text-gray-600";

export const FILTER_TRIGGER_CLASS =
  "flex h-10 w-full items-center justify-between gap-2 rounded-lg border border-[#E5E7EB] bg-white px-3 text-[13px] text-gray-800 outline-none shadow-sm transition hover:border-gray-300 focus:border-[#007BFF] focus:ring-1 focus:ring-[#007BFF]/20";

export const FILTER_TRIGGER_EMBEDDED_CLASS =
  "flex h-full min-h-[32px] w-full min-w-0 flex-1 items-center justify-between gap-2 border-0 bg-transparent px-3 text-left text-xs font-medium outline-none";

export const FILTER_TRIGGER_OPEN_CLASS =
  "border-[#007BFF]/50 ring-1 ring-[#007BFF]/15";

export const FILTER_CHEVRON_CLASS =
  "shrink-0 text-gray-400 transition-transform duration-200";

export const FILTER_DROPDOWN_BTN_RESET = {
  border: "none",
  outline: "none",
  WebkitAppearance: "none",
  appearance: "none",
  boxShadow: "none",
};

export const FILTER_DROPDOWN_LIST_STYLE = {
  listStyle: "none",
  margin: 0,
  padding: "4px 0",
};

export const FILTER_DROPDOWN_LI_RESET = {
  margin: 0,
  padding: 0,
  listStyle: "none",
};

export function getDropdownOptionStyle(selected) {
  return {
    ...FILTER_DROPDOWN_BTN_RESET,
    background: selected ? "rgba(0, 123, 255, 0.08)" : "transparent",
    color: selected ? "#007BFF" : "#4B5563",
    fontWeight: selected ? 600 : 400,
    cursor: "pointer",
    width: "100%",
    textAlign: "left",
    padding: "6px 12px",
  };
}

export function cmsFilterOptionValue(option) {
  if (option == null) return "";
  if (typeof option !== "object") return String(option);
  return String(
    option.value ??
      option.id ??
      option.label ??
      option.name ??
      option.title ??
      option.agencyname ??
      "",
  );
}

export function cmsFilterOptionLabel(option) {
  if (option == null) return "";
  if (typeof option !== "object") return String(option);
  return (
    option.label ||
    option.name ||
    option.title ||
    option.agencyname ||
    cmsFilterOptionValue(option)
  );
}
